import { BaseModel } from '../../_base/crud';

export class PractitionRole extends BaseModel {
  id: number;
  resourceType: string;
  active: boolean;
  period: JSON;
  period_start: string;
  period_end: string;
  notAvailable_description: string;
  notAvailable_during_start: string;
  notAvailable_during_end: string;
  practitioner: JSON;
  doctor_id: number;
  organization: JSON;
  code: any[];
  specialty: any[];
  telecom: any[];
  availableTime: any[];
  notAvailable: any[];
  availabilityExceptions: string;
  healthcareService: any[];
  daysOfWeek: any;
  availableStartTime;
  availableEndTime;

  clear(): void {
    this.id = 0;
    this.resourceType = '';
    this.availabilityExceptions = '';
    this.period_start = '';
    this.period_end = '';
    this.active = false;
    this.period = null;
    this.practitioner = null;
    this.organization = null;
    this.healthcareService = [];
    this.notAvailable = [];
    this.availableTime = [];
    this.telecom = [];
    this.specialty = [];
    this.code = [];
    this.doctor_id = null;
  }
}
